<template>
    <FKBreadCrumb :page="$t('page.create')" >
        <FKBreadCrumbItem :page="$t('page.consents')" :to="`/consents`"/>
    </FKBreadCrumb>
    <ConsentForm />
</template>
  
<script lang="ts">
import { defineComponent } from "vue";

import ConsentForm from "@/components/FK/Consents/ConsentForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";

export default defineComponent({
    name: "CreateConsentPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        ConsentForm,
    },
});
</script>